/**
 * CONFIGURAÇÃO DA API
 * 
 * Altere a URL abaixo para apontar para seu backend PHP
 * Exemplo: 'https://seudominio.com/api'
 */
// Função para gerar um nonce aleatório
const generateNonce = () => {
   const array = new Uint8Array(16);
   window.crypto.getRandomValues(array);
   return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');  
}

export const API_CONFIG = {
  // URL base do seu backend PHP
  BASE_URL: 'https://slots.virtualebank.com.br/api/v1',
  
  // NONCE PARA CSP EVALUTE
  NONCE: generateNonce(),
  
  // Timeout para requisições (em milissegundos)
  TIMEOUT: 10000,
  
  // Nome da chave onde o token será armazenado no localStorage
  TOKEN_KEY: 'purplebet_auth_token',
  
  // Nome da chave onde os dados do usuário serão armazenados
  USER_KEY: 'purplebet_user_data',
} as const;
